const SunIcon = ({ iconColor, ...props }: IIcon) => (
  <svg
    width={23}
    height={24}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.35 5.625a6.376 6.376 0 1 0 6.375 6.376 6.383 6.383 0 0 0-6.375-6.376ZM21.485 10.877h-1.498a1.125 1.125 0 1 0 0 2.25h1.498a1.125 1.125 0 1 0 0-2.25ZM11.35 19.5a1.126 1.126 0 0 0-1.125 1.125v1.5a1.125 1.125 0 0 0 2.248 0v-1.5A1.126 1.126 0 0 0 11.35 19.5ZM3.857 12.002a1.126 1.126 0 0 0-1.125-1.125H1.234a1.125 1.125 0 1 0 0 2.25h1.498a1.126 1.126 0 0 0 1.125-1.125ZM11.35 4.5a1.126 1.126 0 0 0 1.124-1.125v-1.5a1.125 1.125 0 0 0-2.248 0v1.5A1.126 1.126 0 0 0 11.35 4.5ZM18.245 6.697l1.061-1.061a1.125 1.125 0 1 0-1.59-1.59l-1.06 1.06a1.126 1.126 0 0 0 1.224 1.835c.137-.057.26-.14.365-.244ZM18.245 17.307a1.125 1.125 0 1 0-1.59 1.59l1.06 1.061a1.124 1.124 0 1 0 1.59-1.59l-1.06-1.06ZM4.454 17.307l-1.06 1.061a1.124 1.124 0 1 0 1.59 1.59l1.06-1.06a1.125 1.125 0 1 0-1.59-1.59ZM4.455 6.695a1.124 1.124 0 1 0 1.59-1.59l-1.06-1.06a1.124 1.124 0 1 0-1.591 1.59l1.06 1.06Z"
      fill={iconColor}
    />
  </svg>
);

export default SunIcon;
